module.exports = __webpack_public_path__ + "img/layout-tablet-fg.d66cf9ad.png";